import React from "react";
import { Pie } from "react-chartjs-2";

const IssueSeverityChart = ({ data }) => {

  const chartData = {
    labels: ["Critical", "High", "Medium", "Low"],
    datasets: [
      {
        data: data,
        backgroundColor: [
          "#ef4444",
          "#f97316",
          "#eab308",
          "#22c55e"
        ]
      }
    ]
  };

  return (
    <div className="bg-gray-800 p-5 rounded-xl border border-gray-700">
      <h3 className="mb-4 font-semibold text-white">🐞 Issue Severity</h3>
      <Pie data={chartData}/>
    </div>
  );
};

export default IssueSeverityChart;